import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { USER_INVITE_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation DiscardUserInvitation($token: String!) {
    discardUserInvitation(token: $token) {
      ...UserInvite
    }
  }
  ${USER_INVITE_FRAGMENT}
`;

export const discardUserInvitation = (token) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { token },
  }).then(({ data }) => getSingleProp(data));
